export class EntityFilter {
  id: number;
  name: string;
}
